export default function CtaSection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Extremely%20subtle%20delicate%20watercolor%20wash%20texture%20background%20in%20warm%20sand%20and%20soft%20terracotta%20tones%20with%20barely%20visible%20abstract%20geometric%20dot%20grid%20pattern%2C%20ultra%20light%20weight%20paper%20texture%2C%20organic%20handmade%20paper%20feel%2C%20minimal%20barely%20there%20design%2C%20gentle%20warm%20neutral%20palette%2C%20artistic%20wallpaper%20texture%20with%20micro%20detail&width=1800&height=800&seq=cta-bg-pattern-v2&orientation=landscape')`,
        }}
      ></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl p-8 md:p-12 text-center border border-background-200/50">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-5 tracking-wide uppercase">
            15,000+ Curated Product Finds
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Ready to Discover Your Next Favorite Find?
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto mb-8">
            Browse sneakers, hoodies, jackets, accessories, and more across every major shopping spreadsheet — all updated weekly.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              Shop All Categories
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              Kakobuy Sheet
              <i className="ri-store-2-line text-sm"></i>
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10 pt-8 border-t border-background-200/60">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">15K+</div>
              <p className="text-xs text-foreground-500 mt-1">Product Finds</p>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">14</div>
              <p className="text-xs text-foreground-500 mt-1">Categories</p>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">Weekly</div>
              <p className="text-xs text-foreground-500 mt-1">Updates</p>
            </div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">98%</div>
              <p className="text-xs text-foreground-500 mt-1">Verified</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}